import React, { useEffect, useState, useCallback } from 'react'
import PainelPersonalizavel from '../components/PainelPersonalizavel'
import DashboardGraficos from '../components/DashboardGraficos'
import AlertasFolha from '../components/AlertasFolha'
import axios from 'axios'
import { useAuth } from '../contexts/AuthContext'
import { corAlerta, rotuloAlerta } from '../design/tiposAlerta'
import '../design/tokens.css'
const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

const fmtHora = (d:string) => d ? new Date(d).toLocaleString('pt-BR') : '—'
// o alerta de condução mora na tabela de alertas; os demais são e-mails de alerta: cada um tem a sua rota de "lido"
const marcarLidoAlerta = (al:any) => al.origem === 'conducao' ? axios.put(`${API}/alertas/${al.id}/lido`) : axios.put(`${API}/alertas/marcar-lido/${al.id}`)

// Visual do dashboard (proposta aprovada, estilo Apple): tokens do design system, vidro na barra e nas janelas, resposta imediata no toque, um destaque por tela.
const CSS = `
.dash{--db-vidro:rgba(17,24,39,.6);--db-borda:rgba(255,255,255,.14);position:relative;isolation:isolate;height:100%;overflow:auto;overscroll-behavior:contain;background:var(--color-background);color:var(--color-foreground);font:100%/1.5 system-ui,-apple-system,'Segoe UI','SF Pro Text',Roboto,sans-serif;font-optical-sizing:auto}
.dash::before{content:"";position:fixed;inset:0;z-index:-1;pointer-events:none;background:radial-gradient(44rem 24rem at 10% 0%,rgba(11,102,234,.16),transparent 62%),radial-gradient(36rem 22rem at 100% 100%,rgba(25,158,112,.1),transparent 62%)}
.db-vidro,.vidro-folha{background:var(--db-vidro);backdrop-filter:blur(22px) saturate(180%);-webkit-backdrop-filter:blur(22px) saturate(180%);border:1px solid var(--db-borda);border-top-color:rgba(255,255,255,.25);box-shadow:var(--primitive-shadow-md)}
.vidro-folha{--db-vidro:rgba(17,24,39,.78);--db-borda:rgba(255,255,255,.14);border-radius:1.5rem 1.5rem 0 0;color:var(--color-foreground)}
.db-barra{position:sticky;top:0;z-index:6;display:flex;align-items:center;gap:.8rem;padding:.8rem 1.5rem;border-width:0 0 1px 0;box-shadow:none;border-radius:0}
.db-barra h2{margin:0;font-size:1.25rem;letter-spacing:-.02em;font-weight:700}
.db-mini{font-size:.75rem;letter-spacing:.012em;color:var(--color-muted-foreground)}
.db-corpo{padding:1rem 1.5rem 3rem}
.db-kpis{display:grid;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:.75rem;margin:.25rem 0 1.4rem}
.db-kpi{border-radius:1.1rem;padding:1rem 1.1rem;background:var(--color-surface);border:1px solid var(--color-border);text-align:left;font:inherit;color:inherit;display:block;width:100%}
.db-kpi small{display:block;font-size:.6875rem;letter-spacing:.05em;text-transform:uppercase;color:var(--color-muted-foreground);font-weight:600}
.db-kpi strong{display:block;font-size:2.1rem;line-height:1.05;letter-spacing:-.025em;font-weight:700;margin-top:.45rem;font-variant-numeric:tabular-nums}
.db-kpi .rod{font-size:.75rem;color:var(--color-muted-foreground);margin-top:.3rem}
.press{transition:transform 100ms ease-out,background-color 100ms ease-out;cursor:pointer;user-select:none;touch-action:manipulation}
.press:active{transform:scale(.97)}
.db-btn{height:2.1rem;padding:0 .9rem;border-radius:.8rem;border:1px solid var(--color-border-strong);font:inherit;font-size:.8125rem;font-weight:600;background:var(--color-surface);color:var(--color-foreground)}
.db-btn.pri{background:var(--color-primary);border-color:var(--color-primary);color:#fff}
.db-btn:disabled{opacity:.6;cursor:default}
.db-btn:focus-visible,.db-kpi:focus-visible,.db-item:focus-visible,.db-link:focus-visible{outline:3px solid var(--color-ring);outline-offset:2px}
.db-link{background:none;border:0;color:var(--color-primary);font:inherit;font-size:.8125rem;cursor:pointer;padding:.2rem 0;border-radius:.4rem}
.db-titulo{font-size:1.15rem;letter-spacing:-.015em;font-weight:650;margin:1.6rem 0 .7rem}
.db-grade{display:grid;gap:.9rem;grid-template-columns:repeat(auto-fit,minmax(300px,1fr))}
.db-cart{border-radius:1.1rem;padding:1.1rem 1.15rem;background:var(--color-surface);border:1px solid var(--color-border);min-width:0}
.db-cart h3{margin:0 0 .7rem;font-size:.9375rem;letter-spacing:-.01em;font-weight:650}
.db-item{display:flex;align-items:center;gap:.8rem;padding:.8rem .2rem;border-top:1px solid var(--color-border);cursor:pointer;border-radius:.4rem}
.db-item:first-child{border-top:0}
.db-item b{font-weight:600;letter-spacing:-.005em}
.db-dot{width:.6rem;height:.6rem;border-radius:50%;flex:none}
.db-vazio{padding:1.6rem .5rem;text-align:center;color:var(--color-muted-foreground);font-size:.875rem}
.db-lista{overflow:auto;flex:1;touch-action:pan-y;min-height:0}
.db-dados{display:grid;grid-template-columns:1fr 1fr;gap:.6rem;margin:.9rem 0}
.db-dados div{background:var(--color-surface-raised);border-radius:.8rem;padding:.6rem .75rem;font-size:.8125rem}
.db-dados b{display:block;font-size:.6875rem;letter-spacing:.05em;text-transform:uppercase;color:var(--color-muted-foreground);font-weight:600}
.db-vista{animation:db-avanca 220ms cubic-bezier(.22,1,.36,1) both}
.db-vista.volta{animation-name:db-volta}
@keyframes db-avanca{from{opacity:0;transform:translateX(14px)}to{opacity:1;transform:none}}
@keyframes db-volta{from{opacity:0;transform:translateX(-14px)}to{opacity:1;transform:none}}
.db-linha{display:flex;justify-content:space-between;align-items:center;padding:.5rem 0;border-top:1px solid var(--color-border);font-size:.8125rem}
.db-linha:first-of-type{border-top:0}
.db-selo{font-size:.6875rem;font-weight:650;padding:.1rem .55rem;border-radius:1rem;background:var(--color-surface-raised)}
.db-fundo{position:fixed;inset:0;background:var(--color-overlay);z-index:2000;display:flex;align-items:center;justify-content:center;padding:1rem}
.db-dialogo{width:min(560px,100%);max-height:80vh;display:flex;flex-direction:column;border-radius:1.4rem;overflow:hidden;--db-vidro:rgba(17,24,39,.85)}
@media (prefers-reduced-motion:reduce){.db-vista,.db-vista.volta{animation:db-fade 150ms ease both}@keyframes db-fade{from{opacity:0}to{opacity:1}}.press{transition:none}.press:active{transform:none}}
@media (prefers-reduced-transparency:reduce){.db-vidro,.vidro-folha{background:var(--color-surface-raised);backdrop-filter:none;-webkit-backdrop-filter:none}}
@media (prefers-contrast:more){.db-vidro,.vidro-folha{background:var(--color-surface);backdrop-filter:none;-webkit-backdrop-filter:none;border:2px solid var(--color-foreground)}}
`

// "statsIniciais" so serve para testes e para a pre-visualizacao do visual (mostra a tela ja carregada, sem rede)
export default function Dashboard({ statsIniciais, graficosIniciais }: { statsIniciais?: any; graficosIniciais?: Record<string, any> } = {}) {
  const { usuario } = useAuth()
  // cards e paineis internos da plataforma (rastreadores, chips, status do sistema) so aparecem pro superadmin
  const ehSuper = usuario?.perfil === 'superadmin'
  const [stats, setStats] = useState<any>(statsIniciais || {})
  const [loading, setLoading] = useState(!statsIniciais)
  const [ultimaAtt, setUltimaAtt] = useState<Date>(new Date())
  const [countdown, setCountdown] = useState(30)
  const [atualizando, setAtualizando] = useState(false)
  const [folhaAberta, setFolhaAberta] = useState(false)
  const [alertaFolha, setAlertaFolha] = useState<any>(null)
  const [modalBloqueados, setModalBloqueados] = useState(false)
  const [bloqueados, setBloqueados] = useState<any[]>([])
  const [desbloqueando, setDesbloqueando] = useState<string|null>(null)

  const carregarBloqueados = async () => { try { const r = await axios.get(`${API}/dashboard/bloqueados`); setBloqueados(r.data) } catch {} }

  const carregar = useCallback(async (silencioso=false) => {
    if (!silencioso) setLoading(true)
    setAtualizando(true)
    try {
      const r = await axios.get(`${API}/dashboard/stats`)
      setStats(r.data); setUltimaAtt(new Date()); setCountdown(30)
    } catch {}
    finally { setLoading(false); setAtualizando(false) }
  }, [])

  useEffect(() => {
    if (!document.querySelector('#phosphor-bold')) {
      const l = document.createElement('link')
      l.id = 'phosphor-bold'; l.rel = 'stylesheet'
      l.href = 'https://unpkg.com/@phosphor-icons/web@2.1.1/src/bold/style.css'
      document.head.appendChild(l)
    }
    carregar()
    const t = setInterval(() => carregar(true), 30000)
    const cd = setInterval(() => setCountdown(p => p <= 1 ? 30 : p-1), 1000)
    return () => { clearInterval(t); clearInterval(cd) }
  }, [carregar])

  const sa = stats.status_ativos || {}
  const total = stats.total_ativos || 0
  const online = stats.ativos_online || 0
  const offline = total - online
  const alertas: any[] = stats.ultimos_alertas || []

  const abrirLista = () => { setAlertaFolha(null); setFolhaAberta(true) }
  const abrirAlerta = (al:any) => { setAlertaFolha(al); setFolhaAberta(true) }
  const lerAlerta = async (al:any) => { try { await marcarLidoAlerta(al); await carregar(true) } catch {} }
  const lerTodos = async () => { await Promise.allSettled([axios.put(`${API}/alertas/marcar-todos-lidos`), axios.put(`${API}/alertas/todos-lidos`)]); await carregar(true) }   // e-mails de alerta + alertas de condução

  // indicadores: os de plataforma so para o superadmin; um destaque por tela, cor so onde ha algo a fazer
  const kpis: { label:string; valor:any; rod?:string; cor?:string; onClick?:()=>void }[] = [
    ...(ehSuper ? [
      { label:'Clientes', valor:stats.clientes||0, rod:'ativos' },
      { label:'Rastreadores', valor:stats.rastreadores||0, rod:'cadastrados' },
      { label:'Chips SIM', valor:stats.chips||0, rod:`${stats.chips_alerta||0} com alerta`, cor: stats.chips_alerta ? 'var(--color-warning)' : undefined },
    ] : []),
    { label:'Total de ativos', valor:total },
    { label:'Online agora', valor:online, rod:`${offline} offline`, cor:'var(--color-status-moving)' },
    { label:'Em movimento', valor:stats.em_movimento||0, cor:'var(--color-primary)' },
    { label:'Bloqueados', valor:stats.bloqueados||0, rod: stats.bloqueados ? 'toque para ver' : 'nenhum', cor: stats.bloqueados ? 'var(--color-danger)' : undefined, onClick:()=>{ setModalBloqueados(true); carregarBloqueados() } },
    { label:'Alertas não lidos', valor:stats.alertas_hoje||0, rod: stats.alertas_hoje ? 'toque para ver' : 'tudo em dia', cor: stats.alertas_hoje ? 'var(--color-danger)' : undefined, onClick:abrirLista },
  ]

  return (
    <div className="dash dark" data-testid="dashboard">
      <style>{CSS}</style>
      <div className="db-barra db-vidro">
        <h2>Dashboard</h2>
        <span className="db-mini">{atualizando ? 'Atualizando…' : `Atualizado às ${ultimaAtt.toLocaleTimeString('pt-BR')}`}</span>
        <span className="db-mini" title="Próxima atualização automática" style={{ fontVariantNumeric:'tabular-nums' }}>· {countdown}s</span>
        <span style={{ flex:1 }}/>
        <button className="db-btn press" type="button" onClick={()=>carregar(false)}>Atualizar</button>
      </div>

      <div className="db-corpo">
        {loading ? (
          <div className="db-vazio" style={{ padding:'4rem 1rem' }}>Carregando dados…</div>
        ) : (<>
          <div className="db-kpis">
            {kpis.map(k => {
              const conteudo = (<>
                <small>{k.label}</small>
                <strong style={{ color:k.cor || 'inherit' }}>{k.valor}</strong>
                {k.rod && <div className="rod">{k.rod}</div>}
              </>)
              return k.onClick
                ? <button key={k.label} type="button" className="db-kpi press" onClick={k.onClick}>{conteudo}</button>
                : <div key={k.label} className="db-kpi">{conteudo}</div>
            })}
          </div>

          {/* Gráficos (abas A, B e C): uso da frota, operação e custos; mês atual */}
          <DashboardGraficos usuario={usuario} dadosIniciais={graficosIniciais} />

          {ehSuper && (
            <>
              <h3 className="db-titulo">Visão global da plataforma</h3>
              <div className="db-grade">
                <div className="db-cart">
                  <h3>Status da frota (todos os clientes)</h3>
                  {[
                    { label:'Em movimento', valor:parseInt(sa.em_movimento||0), cor:'var(--color-status-moving)' },
                    { label:'Ligado/parado', valor:parseInt(sa.ligado_parado||0), cor:'var(--color-status-idle)' },
                    { label:'Desligado', valor:parseInt(sa.desligado||0), cor:'var(--color-status-off)' },
                    { label:'Sem sinal', valor:parseInt(sa.sem_sinal||0), cor:'var(--color-status-nosignal)' },
                  ].map(s => {
                    const pct = total > 0 ? Math.round(s.valor/total*100) : 0
                    return (
                      <div key={s.label} style={{ marginBottom:'.7rem' }}>
                        <div style={{ display:'flex', justifyContent:'space-between', fontSize:'.8125rem' }}><span>{s.label}</span><b style={{ color:s.cor }}>{s.valor} <span className="db-mini">({pct}%)</span></b></div>
                        <div style={{ height:'.5rem', borderRadius:'1rem', background:'var(--color-surface-raised)', marginTop:'.25rem', overflow:'hidden' }}><div style={{ width:`${pct}%`, height:'100%', background:s.cor, borderRadius:'1rem' }}/></div>
                      </div>
                    )
                  })}
                </div>
                <div className="db-cart">
                  <h3>Manutenção (todos os clientes)</h3>
                  <div className="db-linha"><span>Pendentes</span><b>{stats.manut_pendentes||0}</b></div>
                  <div className="db-linha"><span>Atrasadas</span><b style={{ color: stats.manut_atrasadas ? 'var(--color-danger)' : undefined }}>{stats.manut_atrasadas||0}</b></div>
                  <div className="db-linha"><span>No prazo</span><b>{Math.max(0,(stats.manut_pendentes||0)-(stats.manut_atrasadas||0))}</b></div>
                </div>
                <div className="db-cart">
                  <h3>Chips SIM</h3>
                  <div className="db-linha"><span>Total ativos</span><b>{stats.chips||0}</b></div>
                  <div className="db-linha"><span>Com alerta</span><b style={{ color: stats.chips_alerta ? 'var(--color-warning)' : undefined }}>{stats.chips_alerta||0}</b></div>
                  <div className="db-linha"><span>Normais</span><b>{Math.max(0,(stats.chips||0)-(stats.chips_alerta||0))}</b></div>
                </div>
                <div className="db-cart">
                  <h3>Status do sistema</h3>
                  {[['Backend API','Online'],['Banco de dados','Conectado'],['Traccar GPS','Online'],['Polling GPS','A cada 10s'],['Job de alertas','A cada 5 min'],['Job de manutenção','A cada 6 h'],['Job de chips','A cada 1 h']].map(([n,v]) => (
                    <div key={n} className="db-linha"><span>{n}</span><span className="db-selo">{v}</span></div>
                  ))}
                </div>
              </div>
            </>
          )}

          <h3 className="db-titulo">Últimos alertas</h3>
          <div className="db-cart">
            {!alertas.length ? <div className="db-vazio">Nenhum alerta recente</div> : (<>
              {alertas.slice(0, 6).map((al:any) => (
                <div key={`${al.origem}-${al.id}`} className="db-item press" role="button" tabIndex={0} onClick={()=>abrirAlerta(al)} onKeyDown={(e)=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); abrirAlerta(al) } }}>
                  <span className="db-dot" style={{ background:corAlerta(al.tipo), opacity: al.lido ? .35 : 1 }}/>
                  <div style={{ flex:1, minWidth:0 }}>
                    <b>{al.ativo_nome}{al.placa ? ` · ${al.placa}` : ''}</b>
                    <div className="db-mini">{rotuloAlerta(al.tipo)} · {fmtHora(al.criado_em)}</div>
                  </div>
                  <span className="db-mini">{al.lido ? 'lido' : 'novo'} ›</span>
                </div>
              ))}
              {alertas.length > 6 && <button type="button" className="db-link" style={{ marginTop:'.5rem' }} onClick={abrirLista}>Ver todos os alertas ›</button>}
            </>)}
          </div>
        </>)}

        <h3 className="db-titulo">Painel personalizável</h3>
        <PainelPersonalizavel />
      </div>

      <AlertasFolha aberta={folhaAberta} aoFechar={()=>setFolhaAberta(false)} alertas={alertas} naoLidos={stats.alertas_hoje||0}
        abrirNoAlerta={alertaFolha} aoLer={lerAlerta} aoLerTodos={lerTodos} />

      {modalBloqueados && (
        <div className="db-fundo" onClick={()=>setModalBloqueados(false)}>
          <div className="db-dialogo db-vidro" role="dialog" aria-modal="true" aria-label="Ativos bloqueados" onClick={e=>e.stopPropagation()} onKeyDown={e=>{ if(e.key==='Escape') setModalBloqueados(false) }}>
            <div style={{ padding:'1rem 1.25rem', borderBottom:'1px solid var(--color-border)', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
              <h3 style={{ margin:0, fontSize:'1.1rem', letterSpacing:'-.015em' }}>Ativos bloqueados <span className="db-selo" style={{ color:'var(--color-danger)' }}>{bloqueados.length}</span></h3>
              <button className="db-btn press" type="button" onClick={()=>setModalBloqueados(false)}>Fechar</button>
            </div>
            <div style={{ overflowY:'auto', flex:1, padding:'.4rem 0' }}>
              {!bloqueados.length ? <div className="db-vazio">Nenhum ativo bloqueado</div> : bloqueados.map((b:any) => (
                <div key={b.id} style={{ padding:'.9rem 1.25rem', borderBottom:'1px solid var(--color-border)', display:'flex', justifyContent:'space-between', gap:'.8rem', alignItems:'flex-start' }}>
                  <div style={{ flex:1, minWidth:0 }}>
                    <b>{b.nome}{b.placa ? ` · ${b.placa}` : ''}</b>
                    <div className="db-mini">{b.marca} {b.modelo_veiculo} {b.ano_fabricacao||''}</div>
                    <div className="db-dados" style={{ margin:'.5rem 0' }}>
                      <div><b>Bloqueado em</b>{b.confirmado_em ? fmtHora(b.confirmado_em) : '—'}</div>
                      <div><b>Motorista</b>{b.motorista_nome||'Não identificado'}</div>
                    </div>
                    {b.motivo && <div className="db-mini" style={{ color:'var(--color-danger)' }}>{b.motivo}</div>}
                  </div>
                  <button className="db-btn pri press" type="button" disabled={desbloqueando===b.id}
                    onClick={async()=>{
                      if(!window.confirm(`Desbloquear ${b.nome}?`)) return
                      setDesbloqueando(b.id)
                      try { await axios.post(`${API}/ativos/${b.id}/desbloquear`); await carregarBloqueados(); await carregar(true) }
                      catch(e:any) { alert(e.response?.data?.erro||'Erro ao desbloquear') }
                      finally { setDesbloqueando(null) }
                    }}>{desbloqueando===b.id ? 'Aguarde…' : 'Desbloquear'}</button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
